import { createFileRoute } from '@tanstack/react-router';
import CreateScorecardPage from '../../views/dashboard-scorecard-create';

export type CreateScorecardTab = 'single' | 'chain';

export const Route = createFileRoute('/dashboard/scorecard_/create')({
  // `?tab=chain` opens the Chain (bulk) tab directly so the "New chain
  // search" buttons can deep-link to it. Anything else falls back to single.
  // `?chain=<uuid>` (with tab=chain) targets the search at an existing chain
  // — the "Add locations" flow from a chain detail page. Discovery then
  // excludes locations already in that chain server-side.
  validateSearch: (
    search: Record<string, unknown>,
  ): { tab: CreateScorecardTab; chain?: string } => ({
    tab: search.tab === 'chain' ? 'chain' : 'single',
    chain:
      search.tab === 'chain' && typeof search.chain === 'string' && search.chain
        ? search.chain
        : undefined,
  }),
  component: CreateScorecardPage,
});
